import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { useCopyToClipboard } from '../../../../utils/hooks/useCopyToClipboard';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { addNotification } from '../../../../Notifications/redux/actionCreators';
import { NotificationType } from '../../../../Notifications';
const CopyLinkButton = ({ deviation })=>{
    const { t } = useTranslation();
    var _deviation_shortUrl;
    const copyToClipboard = useCopyToClipboard((_deviation_shortUrl = deviation.shortUrl) !== null && _deviation_shortUrl !== void 0 ? _deviation_shortUrl : '');
    const dispatchAddNotification = useAction(addNotification);
    const handleClick = useCallback(()=>{
        if (deviation.shortUrl) {
            copyToClipboard();
        } else {
            dispatchAddNotification(NotificationType.Generic, {
                message: t('actionbar.stash.copyLink.notification.failure.text')
            });
        }
    }, [
        t,
        deviation,
        dispatchAddNotification,
        copyToClipboard
    ]);
    return /*#__PURE__*/ React.createElement(GhostButton, {
        size: "medium",
        variant: "main",
        onClick: handleClick,
        biData: BiData({
            evid: 357,
            itemid: deviation.deviationId,
            typeid: getDeviationResourceType(deviation)
        })
    }, t('actionbar.stash.copyLink.button.label'));
};
CopyLinkButton.displayName = 'CopyLinkButton';
export default CopyLinkButton;

//# sourceMappingURL=CopyLinkButton.js.map